exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Spinner__spinner___1J4Uz {\n  -webkit-animation: Spinner__spin___avmr0 2s infinite linear;\n          animation: Spinner__spin___avmr0 2s infinite linear;\n  fill: #6d85e9;\n}\n\n@-webkit-keyframes Spinner__spin___avmr0 {\n  0% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n\n@keyframes Spinner__spin___avmr0 {\n  0% {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"spinner": "Spinner__spinner___1J4Uz",
	"spin": "Spinner__spin___avmr0"
};